import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="footer">
      <div className="container-premium">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_lunettes-sur-mesure/artifacts/l7tvoctv_OpticienDeVaires_Logo1_Transparent.png"
                alt="Opticien de Vaires"
                className="h-12 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-[#999999] text-sm leading-relaxed">
              Votre opticien indépendant premium à Vaires-sur-Marne. 
              Spécialiste des montures percées et de la personnalisation.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white font-serif text-lg mb-6">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" data-testid="footer-link-home" className="text-[#999999] hover:text-[#D4AF37] text-sm transition-colors duration-300">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/a-propos" data-testid="footer-link-about" className="text-[#999999] hover:text-[#D4AF37] text-sm transition-colors duration-300">
                  À Propos
                </Link>
              </li>
              <li>
                <Link to="/personnalisation" data-testid="footer-link-customization" className="text-[#999999] hover:text-[#D4AF37] text-sm transition-colors duration-300">
                  Personnalisation
                </Link>
              </li>
              <li>
                <Link to="/contact" data-testid="footer-link-contact" className="text-[#999999] hover:text-[#D4AF37] text-sm transition-colors duration-300">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-serif text-lg mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#D4AF37] flex-shrink-0 mt-0.5" />
                <span className="text-[#999999] text-sm">
                  1 Rue de la Gare<br />
                  77360 Vaires-sur-Marne
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-[#D4AF37] flex-shrink-0" />
                <a href="tel:0182350274" className="text-[#999999] hover:text-[#D4AF37] text-sm transition-colors duration-300">
                  01 82 35 02 74
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-[#D4AF37] flex-shrink-0" />
                <a href="mailto:opt.vaires@gmail.com" className="text-[#999999] hover:text-[#D4AF37] text-sm transition-colors duration-300">
                  opt.vaires@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-white font-serif text-lg mb-6">Horaires</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-3 text-sm">
                <Clock size={18} className="text-[#D4AF37] flex-shrink-0" />
                <span className="text-[#999999]">Lun - Sam : 10h - 19h</span>
              </li>
              <li className="text-[#999999] text-sm pl-8">Dimanche : Fermé</li>
            </ul>
            <div className="mt-6 p-4 bg-[#2A2A2A] rounded-none">
              <p className="text-[#D4AF37] text-xs uppercase tracking-widest mb-1">Accès</p>
              <p className="text-[#999999] text-sm">En face de la gare RER P</p>
              <p className="text-[#999999] text-sm">Parking gratuit 1h30</p>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-[#333333] pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#666666] text-xs">
            © {new Date().getFullYear()} Optique Vaires. Tous droits réservés.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-[#666666] hover:text-[#D4AF37] text-xs transition-colors duration-300">
              Mentions légales
            </a>
            <a href="#" className="text-[#666666] hover:text-[#D4AF37] text-xs transition-colors duration-300">
              Politique de confidentialité
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
